'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
function $ct_Lio_intela_sites_digitalinternship_ui_Button__T__($thiz, classes) {
  $thiz.fF = classes;
  return $thiz;
}
export { $ct_Lio_intela_sites_digitalinternship_ui_Button__T__ as $ct_Lio_intela_sites_digitalinternship_ui_Button__T__ };
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_ui_Button() {
  this.fF = null;
}
export { $c_Lio_intela_sites_digitalinternship_ui_Button as $c_Lio_intela_sites_digitalinternship_ui_Button };
$p = $c_Lio_intela_sites_digitalinternship_ui_Button.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_ui_Button;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_ui_Button() {
}
export { $h_Lio_intela_sites_digitalinternship_ui_Button as $h_Lio_intela_sites_digitalinternship_ui_Button };
$h_Lio_intela_sites_digitalinternship_ui_Button.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.Ax = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sc_StringOps$().Bd(this.fF, " btn-lg");
});
//# sourceMappingURL=io.intela.sites.digitalinternship.ui.-Button.js.map
